import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { guessLocale, supportedLocales, translation, } from '@tymia/main-api';
import { ensureDefined, } from '@tymia/shared';
import { useState, } from 'react';
import { omit, } from 'remeda';
import { api, } from '../api/Api.js';
import { useConfig, } from '../common/config/ConfigProvider.js';
import { configStore, } from '../common/config/ConfigStore.js';
import { ArrowDropDownIcon, } from '../pages/search/icons/ArrowDropDownIcon.js';
const translations = supportedLocales().map(locale => {
    const tRoot = translation(locale);
    return {
        locale,
        label: tRoot.name,
        direction: tRoot.dir,
        region: tRoot.region,
    };
});
export function LanguageSwitcher({ className = '', }) {
    const config = useConfig();
    const [isOpen, setIsOpen] = useState(false);
    const currentLanguage = ensureDefined(translations
        .find(({ locale }) => locale === config.locale));
    async function handleLanguageChange(languageCode) {
        const response = await api.common.config.request({
            userLocale: languageCode,
            stateLocale: config.locale,
        });
        if (response.status === 'ok') {
            const locale = guessLocale(response.locale);
            configStore.set({
                ...config,
                ...omit(response, ['status']),
                locale,
            });
        }
        setIsOpen(false);
    }
    return (_jsx("div", { className: className, children: _jsxs("div", { className: "relative inline-block", onBlur: event => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                    setIsOpen(false);
                }
            }, children: [_jsxs("button", { type: "button", onClick: () => setIsOpen(open => !open), "aria-haspopup": "listbox", "aria-expanded": isOpen, className: "flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-800 shadow-sm transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400", children: [_jsxs("span", { dir: currentLanguage.direction, className: "text-start", children: [currentLanguage.label, currentLanguage.region && (` (${currentLanguage.region})`)] }), _jsx(ArrowDropDownIcon, { size: 24, className: `fill-tym-green transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}` })] }), _jsx("div", { className: `absolute top-full inset-e-0 w-48 origin-top pt-2 transition-all duration-200 ease-out ${isOpen
                        ? 'translate-y-0 scale-y-100 opacity-100'
                        : 'pointer-events-none -translate-y-2 scale-y-95 opacity-0'}`, children: _jsx("ul", { role: "listbox", className: "overflow-hidden rounded-xl border border-slate-200 bg-white py-2 shadow-lg", children: translations.map(language => {
                            const isCurrent = language.locale === currentLanguage.locale;
                            return (_jsx("li", { children: _jsx("button", { type: "button", role: "option", "aria-selected": isCurrent, onClick: () => handleLanguageChange(language.locale), className: `flex w-full items-center gap-3 px-4 py-2 text-sm transition ${isCurrent
                                        ? 'bg-slate-100 font-semibold text-slate-950'
                                        : 'text-slate-700 hover:bg-slate-50'}`, children: _jsxs("span", { dir: language.direction, className: "min-w-0 flex-1 text-start", children: [language.label, language.region && (` (${language.region})`)] }) }) }, language.locale));
                        }) }) })] }) }));
}
//# sourceMappingURL=LanguageSwitcher.js.map